<script>
import { mapActions } from 'vuex';
import { PaymentMethodOptions } from '@/enums/paymentMethods';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Shops'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Shops',
            actions: [
                {
                    icon: 'fab fa-product-hunt',
                    method: 'goToProducts'
                }
            ]
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '180px' },
                {
                    value: 'slug',
                    width: '180px'
                },
                {
                    value: 'payWithStars',
                    width: '150px',
                    type: 'boolean',
                    filter: val => (val ? 'Yes' : '-')
                },
                {
                    width: '200px',
                    text: 'Campus',
                    sortable: false,
                    value: 'campuses',
                    filterFieldName: 'campuses.name',
                    filter: 'joinTable'
                },
                {
                    value: 'terminal',
                    width: '180px',
                    type: 'enum',
                    enumOptions: PaymentMethodOptions,
                    isEnumOptionLabeled: true,
                    filter: 'terminal'
                },
                {
                    value: 'createdAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'shops/index',
            deleteItem: 'shops/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/shops/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/shops/add');
        },
        goToProducts(id) {
            this.$router.push(`/shops/${id}/products`);
        }
    }
};
</script>
